import React from 'react';
import Marquee from 'react-fast-marquee';
import Abel from '../images/clients/abel.png';
import ArthaUtama from '../images/clients/artha-utama.png';
import Delameta from '../images/clients/delameta.png';
import Dermozone from '../images/clients/dermozone.png';
import HosanaMedika from '../images/clients/hosana-medika.png';
import Kanemory from '../images/clients/kanemory.png';
import MuliaBogaRaya from '../images/clients/mulia-boga-raya.png';
import PrimaEquipment from '../images/clients/prima-equipment.png';
import RPAC from '../images/clients/rpac.png';
import RSHK from '../images/clients/rshk.png';
import Shuangfei from '../images/clients/shuangfei.png';
import SKMetalindo from '../images/clients/sk-metalindo.png';
import TunasAlfin from '../images/clients/tunas-alfin.png';
import XCMGG from '../images/clients/xcmg.png';
import SectionHeading from './SectionHeading';

const clientLogos = [
    Abel, ArthaUtama, Delameta, Dermozone, HosanaMedika,
    Kanemory, MuliaBogaRaya, PrimaEquipment, RPAC, RSHK,
    Shuangfei, SKMetalindo, TunasAlfin, XCMGG
];

const Clients = () => {
    return (
        <div className="py-16 md:py-20">
            <section data-aos="fade-up" className="container-app">
                <SectionHeading
                    eyebrow="Mitra Kerja"
                    title="Telah Dipercaya Berbagai Mitra Kerja"
                    subtitle="Kualitas sumber daya manusia yang terseleksi dengan baik dengan sistem keamanan yang terintegrasi menjadikan BSW dipercaya oleh beberapa mitra kerja."
                />

                <div className="relative mt-4" data-aos="fade-in" data-aos-delay="300">
                    <Marquee
                        speed={50}
                        gradient={true}
                        gradientWidth={100}
                        pauseOnHover
                    >
                        {clientLogos.map((image, index) => (
                            <div
                                key={index}
                                className="mx-4 flex items-center justify-center h-28 w-28 rounded-xl bg-white border border-slate-100 shadow-sm p-4 transition-all duration-300 hover:shadow-card hover:-translate-y-0.5"
                            >
                                <img
                                    src={image}
                                    alt="client"
                                    className="max-h-full max-w-full object-contain grayscale opacity-70 transition-all duration-300 hover:grayscale-0 hover:opacity-100"
                                />
                            </div>
                        ))}
                    </Marquee>
                </div>
            </section>
        </div>
    )
}

export default Clients;
